class OccupationSearch {
    constructor() {
        this.searchContainer = ".js-occupation-search";
        this.form = document.querySelector(".js-occupation-search-form");
        this.searchInput = document.getElementById("occupation-search");
        this.searchSubmit = Array.from(document.querySelectorAll(".js-occupation-search-submit"));
        this.clearSearchTrigger = '.js-clear-occupation-search'
    }

    handleClearTriggerClick() {
        const triggers = Array.from(document.querySelectorAll(this.clearSearchTrigger));
        triggers.forEach(trigger => {
            trigger.addEventListener("click", e => {
                let url = window.location.href;
                let pushLocation = url.split('?')[0];
                window.location.href = pushLocation;
            });
        });
    }

    init() {
        this.handleClearTriggerClick();
        if (this.searchInput) {
            this.searchInput.addEventListener('keydown', (event) => {
                const code = (event.keyCode ? event.keyCode : event.which);
                if(code == 13) {
                    event.cancelBubble = true;
                    event.returnValue = false;
                    event.stopImmediatePropagation();
                    event.stopPropagation();
                    event.preventDefault();
                    return false;
                }
            });
        }

        // Define Autocomplete
        const autoCompleteInput = this.searchInput;
        const autoCompleteOptions = {
            types: ['(regions)'],
            componentRestrictions: {
                country: 'au',
            },
        };

        window.initOccupationSearch = () => {
            if (this.searchInput) {
                const autoComplete = new google.maps.places.Autocomplete(autoCompleteInput, autoCompleteOptions);
                autoComplete.addListener('place_changed', () => {
                    const place = autoComplete.getPlace();
                    const suburb = [];
                    const postcode = [];
                    if(place.hasOwnProperty('address_components')) {
                        place.address_components.forEach(function(addressComponent, i) {
                            if(addressComponent.types.indexOf("locality") >= 0) {
                                suburb.push(addressComponent.long_name);
                            } else if(addressComponent.types.indexOf("postal_code") >= 0) {
                                postcode.push(addressComponent.long_name);
                            }
                        });
                    }

                    if ('URLSearchParams' in window) {
                        var searchParams = new URLSearchParams(window.location.search);
                        searchParams.set("postcode", postcode.join(' '));
                        searchParams.set("suburb", suburb.join(' '));
                        const origin = window.location.origin;
                        const path = this.form.getAttribute('action').toString();
                        const searchString = searchParams.toString();
                        const url = origin.concat(path).concat('?').concat(searchString);
                        window.location.href = url;
                    }
                });
            }
        }
    }
}

export default OccupationSearch;



// WEBPACK FOOTER //
// ../project/craft/src/components/occupation-search/occupation-search.js